/**
 * Lightweight, store-agnostic notifier for transient connectivity trouble:
 * a request timeout, a network-level fetch failure, or a gateway 5xx
 * (502/503/504). The low-level fetch layer in `api.js` (plain, non-React code)
 * emits; the TopBar `GenericError` banner subscribes and shows briefly.
 *
 * Kept out of Redux on purpose so the fetch layer doesn't need store access,
 * and SSR-safe (no window/DOM dependency).
 */

const listeners = new Set();

/**
 * Subscribe to network-trouble notifications.
 * @param {() => void} listener
 * @returns {() => void} unsubscribe
 */
export const subscribeNetworkTrouble = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Notify all subscribers that a request hit transient connectivity trouble.
 * A throwing subscriber must never break the request path.
 */
export const notifyNetworkTrouble = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // Ignore subscriber errors — signaling trouble must not itself throw.
    }
  });
};
